import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/components/ui/sidebar'
import { useStytchWorkspaces } from '@/hooks/useStytchWorkspaces'
import { useAppDispatch } from '@/redux/hooks/useAppState'
import { setIsWorkspaceSelectorOpen } from '@/redux/store/slices/ui/uiSlice'
import { Organization } from '@stytch/vanilla-js'
import { Building2, ChevronsUpDown } from 'lucide-react'
import * as React from 'react'
import { useParams } from 'react-router-dom'

export function WorkspaceSwitcher() {
	const { workspaceId = '' } = useParams()
	const { workspaces } = useStytchWorkspaces()
	const dispatch = useAppDispatch()
	const workspaceMap = workspaces.reduce(
		(mp, workspace) => {
			mp[workspace.organization_slug] = workspace
			return mp
		},
		{} as Record<string, Organization>
	)

	const currentWorkspace = workspaceMap[workspaceId] ?? workspaces[0]

	const openWorkspaceSelector = React.useCallback(() => {
		dispatch(setIsWorkspaceSelectorOpen(true))
	}, [dispatch])

	if (!currentWorkspace) {
		return null
	}

	const tooltip = `Workspace: ${currentWorkspace.organization_name}`

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<SidebarMenuButton
					onClick={openWorkspaceSelector}
					tooltip={tooltip}
					size="lg"
					className="hover:bg-sidebar-accent hover:text-sidebar-accent-foreground data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
				>
					<div className="bg-muted flex aspect-square size-8 items-center justify-center rounded-lg">
						<Building2 className="size-4" />
					</div>
					<div className="grid flex-1 text-left text-sm leading-tight">
						<span className="truncate font-medium">{currentWorkspace.organization_name}</span>
					</div>
					<ChevronsUpDown className="ml-auto size-4" />
				</SidebarMenuButton>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}
